import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

export const TradingPairHeaderSkeleton: React.FC = () => (
  <Root>
    <Header>
      <Left>
        <Skeleton width={120} height={15} />
        <Skeleton width={60} height={5} />
      </Left>
      <Right>
        <Skeleton width={60} height={30} />
      </Right>
      <Right>
        <Skeleton width={50} height={5} />
        <Skeleton width={70} height={15} />
      </Right>
    </Header>
  </Root>
)

const Root = styled.div`
  padding-inline: 6px;
  padding-block: 6px;
  background: var(--background-3);
  border-radius: 12px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
`

const Header = styled.div`
  height: 56px;
  border-radius: 12px;
  z-index: 10;
  background: var(--appearance-1);

  grid-template-columns: 1fr 1fr 90px;
  display: grid;
  align-items: center;
`

const Left = styled.div`
  display: flex;
  flex-direction: column;

  gap: 4px;
  padding-inline: 10px;
`

const Right = styled(Left)`
  align-items: flex-end;
`
